// Indicates if a given WordPress post status is "unpublished" or not.
// Unpublished posts are visible by admins only.
export default function isUnpublishedPost(status: string | undefined): boolean {
  return !!status && ['draft', 'private', 'future', 'pending'].includes(status);
}
